// The slice variable is the part of the state that you want to get loading from
//  ex. getFormIsActive('settingsForm')(state)

export default function getLoadingFromState(slice) {
  return state => Boolean(state.getIn(['form', slice, 'active'], false));
}
